import { Container, Input } from 'components/atoms';
import ViewHint from 'components/molecules/hint/ViewHint';

import { t } from 'i18next';
import { PiUser, PiUserCircle } from 'react-icons/pi';
import { useGetLabel } from 'services/labels';
import { CUSTOMER_TYPE } from 'services/labels/types';

const LabelBasicInformation = () => {
  const { data: label, isLoading } = useGetLabel(false);
  const customerTypeKey =
    label?.customerTypeId != null ? CUSTOMER_TYPE[label.customerTypeId] : undefined;
  return (
    <>
      <div />
      <ViewHint hintId="label-basic-information" />

      <Input.Text
        label={t('input.label.customerType')}
        name="customerType"
        readOnly
        value={customerTypeKey ? t(`enum.CUSTOMER_TYPE.${customerTypeKey}`) : ''}
      />

      <Input.Text name="Name" label={t('input.label.name')} value={label?.labelName} readOnly />
    </>
  );
};

export default LabelBasicInformation;
